// Code generated by apic; DO NOT EDIT.
import type { ServiceMetadata } from "./types";export const SERVICE_METADATA: ServiceMetadata = {
  apiPrefix: "/v1",
  rest: [
    {
      method: "POST",
      path: "/v1/admin/keys/rotate",
      methodName: "AdminRotateSigningKeys",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRotateSigningKeysReq",
      responseSchema: "AdminRotateSigningKeysResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/mtls/cas",
      methodName: "AdminListClientCAs",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminMTLSEmptyReq",
      responseSchema: "AdminClientCAListResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/mtls/cas",
      methodName: "AdminCreateClientCA",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateClientCAReq",
      responseSchema: "AdminClientCAResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/mtls/cas/{id}",
      methodName: "AdminDeleteClientCA",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetClientCAReq",
      responseSchema: "AdminClientCAResp",
      pathParams: ["id"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/mtls/cas/{id}",
      methodName: "AdminGetClientCA",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetClientCAReq",
      responseSchema: "AdminClientCAResp",
      pathParams: ["id"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/mtls/cas/{id}",
      methodName: "AdminUpdateClientCA",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateClientCAReq",
      responseSchema: "AdminClientCAResp",
      pathParams: ["id"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/mtls/status",
      methodName: "AdminMTLSStatus",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminMTLSEmptyReq",
      responseSchema: "AdminMTLSStatusResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants",
      methodName: "AdminListTenants",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListTenantsReq",
      responseSchema: "AdminListTenantsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants",
      methodName: "AdminCreateTenant",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateTenantReq",
      responseSchema: "AdminTenantResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}",
      methodName: "AdminDeleteTenant",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetTenantReq",
      responseSchema: "AdminTenantResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}",
      methodName: "AdminGetTenant",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetTenantReq",
      responseSchema: "AdminTenantResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}",
      methodName: "AdminUpdateTenant",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateTenantReq",
      responseSchema: "AdminTenantResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/access-requests/",
      methodName: "AdminListAccessRequests",
      description: "Lists a tenant's access requests in keyset pages ordered by id. The optional subject, approver, resource and status filters AND together inside the store query. subject accepts a canonical PAM subject id or a caller's access-token sub, such as a ThreadID user id. ThreadID resolves it the way the self-service PAM surface resolves a token sub: an exact subject id, then a linked user id, then an external id held by exactly one subject, each only for an active subject. A value that resolves to no active subject returns an empty page, and a value that matches more than one active subject is refused with 409 Conflict. The filter is never dropped or widened. unexpired=true keeps only requests whose expires_at is set and later than the server's current time, evaluated inside the store query before pagination: in practice activated requests whose grant is still live. Pending and approved requests have no expires_at and are excluded. A PAM reader client may also call this route: an app-bound, confidential client_credentials client with no admin role, holding a pam-reader governance grant in its home tenant, and listed for this tenant by the operator's THREADID_PAM_READER_TENANTS allow-list. Every admitted read is audited and rate-limited per client (429 with Retry-After), and the reader's token lives five minutes. A PAM reader must pass subject: an unfiltered read is refused with 400 Bad Request. Only for that caller, each row carries linked_user_id and subject_lifecycle, so the caller can bind a row to the user it acts for, and each row's purpose and justification are empty. Rows returned to any other caller omit both binding fields and carry the purpose and justification.",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAccessRequestsReq",
      responseSchema: "AdminListAccessRequestsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/",
      methodName: "AdminCreateAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}",
      methodName: "AdminGetAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/activate",
      methodName: "AdminActivateAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAccessRequestReq",
      responseSchema: "PamAccessRequestActivationResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/approve",
      methodName: "AdminApproveAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminApproveAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/cancel",
      methodName: "AdminCancelAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/deny",
      methodName: "AdminDenyAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminDenyAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/evidence",
      methodName: "AdminGetAccessRequestEvidence",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/evidence-package",
      methodName: "AdminGetAccessRequestEvidencePackage",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/access-requests/{requestId}/extend",
      methodName: "AdminExtendAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminExtendAccessRequestReq",
      responseSchema: "AdminAccessRequestResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apikeys",
      methodName: "AdminListAPIKeys",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAPIKeysReq",
      responseSchema: "AdminListAPIKeysResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apikeys",
      methodName: "AdminMintAPIKey",
      description: "Mints a new App-bound API-key JWT, gated by PermTenantAPIKeysManage (ThreadID API keys core). Returns the signed JWT exactly ONCE -- it is never retrievable again; only metadata is returned by subsequent list/get calls.",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminMintAPIKeyReq",
      responseSchema: "AdminAPIKeySecretResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/apikeys/{keyId}",
      methodName: "AdminRevokeAPIKey",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAPIKeyReq",
      responseSchema: "AdminAPIKeyResp",
      pathParams: ["tenantId", "keyId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apikeys/{keyId}",
      methodName: "AdminGetAPIKey",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAPIKeyReq",
      responseSchema: "AdminAPIKeyResp",
      pathParams: ["tenantId", "keyId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apikeys/{keyId}/rotate",
      methodName: "AdminRotateAPIKey",
      description: "Mints a successor API-key JWT bound to the same App, with rotated_from set to the predecessor's key_id. The predecessor key remains valid (not revoked) -- callers must revoke it separately once the rotation is complete.",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRotateAPIKeyReq",
      responseSchema: "AdminAPIKeySecretResp",
      pathParams: ["tenantId", "keyId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps",
      methodName: "AdminListApps",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAppsReq",
      responseSchema: "AdminListAppsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apps",
      methodName: "AdminCreateApp",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateAppReq",
      responseSchema: "AdminAppResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}",
      methodName: "AdminDeleteApp",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppReq",
      responseSchema: "AdminAppResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}",
      methodName: "AdminGetApp",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppReq",
      responseSchema: "AdminAppResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}",
      methodName: "AdminUpdateApp",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateAppReq",
      responseSchema: "AdminAppResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/children",
      methodName: "AdminListAppChildren",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAppChildrenReq",
      responseSchema: "AdminListAppsResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/claims-surface",
      methodName: "AdminDeleteAppClaimsSurface",
      description: "Clears this App's OWN claims-surface rules; inherited rules from ancestor Apps apply again. GATED LIKE THE PUT (docs/design/claims-surface.md §6): when clearing this App's rules would newly add a name to the App's EFFECTIVE, chain-merged required set -- which is what happens when the cleared rules were masking an ancestor's required:true with required:false or with a suppression -- the request is refused with 428 Precondition Required unless it carries a preview token, and with 400 Bad Request when the token does not authorise this clear. Because a DELETE has no body the token travels in the X-Claims-Surface-Preview-Token request header, and it must be the token returned by POST .../claims-surface/preview for the EMPTY candidate rule set, which is what a clear leaves behind. A clear that changes nothing about the effective required set needs no token.",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppReq",
      responseSchema: "AdminAppClaimsSurfaceResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/claims-surface",
      methodName: "AdminGetAppClaimsSurface",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppClaimsSurfaceReq",
      responseSchema: "AdminAppClaimsSurfaceResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/claims-surface",
      methodName: "AdminPutAppClaimsSurface",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPutAppClaimsSurfaceReq",
      responseSchema: "AdminAppClaimsSurfaceResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/claims-surface/preview",
      methodName: "AdminPreviewAppClaimsSurface",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPreviewAppClaimsSurfaceReq",
      responseSchema: "AdminAppClaimsSurfacePreviewResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles",
      methodName: "AdminListAppRoles",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAppRolesReq",
      responseSchema: "AdminListAppRolesResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles",
      methodName: "AdminCreateAppRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateAppRoleReq",
      responseSchema: "AdminAppRoleResp",
      pathParams: ["tenantId", "appId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}",
      methodName: "AdminDeleteAppRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppRoleReq",
      responseSchema: "AdminAppRoleResp",
      pathParams: ["tenantId", "appId", "roleId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}",
      methodName: "AdminGetAppRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAppRoleReq",
      responseSchema: "AdminAppRoleResp",
      pathParams: ["tenantId", "appId", "roleId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}",
      methodName: "AdminUpdateAppRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateAppRoleReq",
      responseSchema: "AdminAppRoleResp",
      pathParams: ["tenantId", "appId", "roleId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}/assignments",
      methodName: "AdminListAppRoleAssignments",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAppRoleAssignmentsReq",
      responseSchema: "AdminListAppRoleAssignmentsResp",
      pathParams: ["tenantId", "appId", "roleId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}/assignments",
      methodName: "AdminCreateAppRoleAssignment",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateAppRoleAssignmentReq",
      responseSchema: "AdminAppRoleAssignmentResp",
      pathParams: ["tenantId", "appId", "roleId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/apps/{appId}/roles/{roleId}/assignments/{assignmentId}",
      methodName: "AdminDeleteAppRoleAssignment",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminDeleteAppRoleAssignmentReq",
      responseSchema: "AdminAppRoleAssignmentResp",
      pathParams: ["tenantId", "appId", "roleId", "assignmentId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/audit",
      methodName: "AdminQueryAudit",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminQueryAuditReq",
      responseSchema: "AdminQueryAuditResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/audit/case-file/{requestId}",
      methodName: "AdminGetAuditCaseFile",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAuditCaseFileReq",
      responseSchema: "AdminQueryAuditResp",
      pathParams: ["tenantId", "requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/audit/chain-integrity",
      methodName: "AdminGetAuditChainIntegrity",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetAuditChainIntegrityReq",
      responseSchema: "AdminGetAuditChainIntegrityResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/audit/chain-rebaseline",
      methodName: "AdminRebaselineAuditChain",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRebaselineAuditChainReq",
      responseSchema: "AdminRebaselineAuditChainResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/break-glass/",
      methodName: "AdminListBreakGlassEvents",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListBreakGlassEventsReq",
      responseSchema: "AdminListBreakGlassEventsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/break-glass/",
      methodName: "AdminActivateBreakGlass",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminActivateBreakGlassReq",
      responseSchema: "AdminBreakGlassEventResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/break-glass/unreviewed",
      methodName: "AdminListUnreviewedBreakGlassEvents",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListBreakGlassEventsReq",
      responseSchema: "AdminListBreakGlassEventsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/break-glass/{eventId}",
      methodName: "AdminGetBreakGlassEvent",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetBreakGlassEventReq",
      responseSchema: "AdminBreakGlassEventResp",
      pathParams: ["tenantId", "eventId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/break-glass/{eventId}/review",
      methodName: "AdminCompleteBreakGlassReview",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCompleteBreakGlassReviewReq",
      responseSchema: "AdminBreakGlassEventResp",
      pathParams: ["tenantId", "eventId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions",
      methodName: "AdminListBrokeredSessions",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListBrokeredSessionsReq",
      responseSchema: "AdminListBrokeredSessionsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions",
      methodName: "AdminInitiateBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminInitiateBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}",
      methodName: "AdminKillBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminKillBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}",
      methodName: "AdminGetBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}/monitor",
      methodName: "AdminMonitorBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 300,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}/pause",
      methodName: "AdminPauseBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}/recordings",
      methodName: "AdminGetBrokeredSessionRecordings",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetBrokeredSessionRecordingsReq",
      responseSchema: "AdminGetBrokeredSessionRecordingsResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/brokered-sessions/{sessionId}/resume",
      methodName: "AdminResumeBrokeredSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminResumeBrokeredSessionReq",
      responseSchema: "AdminBrokeredSessionResp",
      pathParams: ["tenantId", "sessionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/cae/config",
      methodName: "AdminGetCAEConfig",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCAEConfigReq",
      responseSchema: "AdminCAEConfigResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/cae/config",
      methodName: "AdminUpdateCAEConfig",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateCAEConfigReq",
      responseSchema: "AdminUpdateCAEConfigResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/cae/evaluate/{subjectId}",
      methodName: "AdminTriggerCAEEvaluate",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminTriggerCAEEvaluateReq",
      responseSchema: "AdminTriggerCAEEvaluateResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/cae/events",
      methodName: "AdminListCAEEvents",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListCAEEventsReq",
      responseSchema: "AdminListCAEEventsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/cae/events/{eventId}",
      methodName: "AdminGetCAEEvent",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCAEEventReq",
      responseSchema: "AdminCAEEventResp",
      pathParams: ["tenantId", "eventId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/cae/risk",
      methodName: "AdminListHighRiskSubjects",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListHighRiskSubjectsReq",
      responseSchema: "AdminListHighRiskSubjectsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/cae/risk/{subjectId}",
      methodName: "AdminGetCAERiskState",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCAERiskStateReq",
      responseSchema: "AdminCAERiskStateResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/cae/risk/{subjectId}",
      methodName: "AdminOverrideCAERisk",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminOverrideCAERiskReq",
      responseSchema: "AdminOverrideCAERiskResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/clients",
      methodName: "AdminListClients",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListClientsReq",
      responseSchema: "AdminListClientsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/clients",
      methodName: "AdminCreateClient",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateClientReq",
      responseSchema: "AdminCreateClientResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/clients/{clientId}",
      methodName: "AdminDeleteClient",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetClientReq",
      responseSchema: "AdminClientResp",
      pathParams: ["tenantId", "clientId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/clients/{clientId}",
      methodName: "AdminGetClient",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetClientReq",
      responseSchema: "AdminClientResp",
      pathParams: ["tenantId", "clientId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/clients/{clientId}",
      methodName: "AdminUpdateClient",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateClientReq",
      responseSchema: "AdminClientResp",
      pathParams: ["tenantId", "clientId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/clients/{clientId}/rotate-secret",
      methodName: "AdminRotateClientSecret",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRotateClientSecretReq",
      responseSchema: "AdminRotateClientSecretResp",
      pathParams: ["tenantId", "clientId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/connectors",
      methodName: "AdminListConnectors",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListConnectorsReq",
      responseSchema: "AdminListConnectorsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/connectors",
      methodName: "AdminCreateConnector",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateConnectorReq",
      responseSchema: "AdminConnectorResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/connectors/{connectorId}",
      methodName: "AdminDeleteConnector",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetConnectorReq",
      responseSchema: "AdminConnectorResp",
      pathParams: ["tenantId", "connectorId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/connectors/{connectorId}",
      methodName: "AdminGetConnector",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetConnectorReq",
      responseSchema: "AdminConnectorResp",
      pathParams: ["tenantId", "connectorId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/connectors/{connectorId}",
      methodName: "AdminUpdateConnector",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateConnectorReq",
      responseSchema: "AdminConnectorResp",
      pathParams: ["tenantId", "connectorId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/device-posture",
      methodName: "AdminUpsertDevicePosture",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpsertDevicePostureReq",
      responseSchema: "AdminDevicePostureResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/device-posture/{deviceId}",
      methodName: "AdminGetDevicePosture",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetDevicePostureReq",
      responseSchema: "AdminDevicePostureResp",
      pathParams: ["tenantId", "deviceId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/emergency-roles/",
      methodName: "AdminListEmergencyRoles",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListEmergencyRolesReq",
      responseSchema: "AdminListEmergencyRolesResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/emergency-roles/",
      methodName: "AdminCreateEmergencyRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateEmergencyRoleReq",
      responseSchema: "AdminEmergencyRoleResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/emergency-roles/{roleId}",
      methodName: "AdminDeleteEmergencyRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetEmergencyRoleReq",
      responseSchema: "AdminEmergencyRoleResp",
      pathParams: ["tenantId", "roleId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/emergency-roles/{roleId}",
      methodName: "AdminGetEmergencyRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetEmergencyRoleReq",
      responseSchema: "AdminEmergencyRoleResp",
      pathParams: ["tenantId", "roleId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/emergency-roles/{roleId}",
      methodName: "AdminUpdateEmergencyRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateEmergencyRoleReq",
      responseSchema: "AdminEmergencyRoleResp",
      pathParams: ["tenantId", "roleId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/entitlements",
      methodName: "AdminListEntitlements",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListEntitlementsReq",
      responseSchema: "AdminListEntitlementsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/entitlements",
      methodName: "AdminCreateEntitlement",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateEntitlementReq",
      responseSchema: "AdminEntitlementResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/entitlements/{entitlementId}",
      methodName: "AdminDeleteEntitlement",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetEntitlementReq",
      responseSchema: "AdminEntitlementResp",
      pathParams: ["tenantId", "entitlementId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/entitlements/{entitlementId}",
      methodName: "AdminGetEntitlement",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetEntitlementReq",
      responseSchema: "AdminEntitlementResp",
      pathParams: ["tenantId", "entitlementId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/entitlements/{entitlementId}",
      methodName: "AdminUpdateEntitlement",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateEntitlementReq",
      responseSchema: "AdminEntitlementResp",
      pathParams: ["tenantId", "entitlementId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/issue",
      methodName: "AdminIssueEphemeralCred",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminIssueEphemeralCredReq",
      responseSchema: "AdminEphemeralCredResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/leases",
      methodName: "AdminListCredentialLeases",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListCredentialLeasesReq",
      responseSchema: "AdminListCredentialLeasesResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/leases/{id}",
      methodName: "AdminGetCredentialLease",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCredentialLeaseReq",
      responseSchema: "AdminCredentialLeaseResp",
      pathParams: ["tenantId", "id"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/leases/{id}/revoke",
      methodName: "AdminRevokeCredentialLease",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCredentialLeaseReq",
      responseSchema: "AdminRevokeCredentialLeaseResp",
      pathParams: ["tenantId", "id"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/providers",
      methodName: "AdminListCredentialProviders",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListCredentialProvidersReq",
      responseSchema: "AdminListCredentialProvidersResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/ephemeral-creds/rotate-key",
      methodName: "AdminRotateCredentialKey",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRotateCredentialKeyReq",
      responseSchema: "AdminRotateCredentialKeyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns",
      methodName: "AdminGovernanceListCampaigns",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListDiscoveryReq",
      responseSchema: "AdminListCampaignsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns",
      methodName: "AdminGovernanceCreateCampaign",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateCampaignReq",
      responseSchema: "AdminCampaignResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns/{campaignId}",
      methodName: "AdminGovernanceGetCampaign",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetCampaignReq",
      responseSchema: "AdminCampaignResp",
      pathParams: ["tenantId", "campaignId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns/{campaignId}/attestations",
      methodName: "AdminGovernanceListAttestations",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListAttestationsReq",
      responseSchema: "AdminListAttestationsResp",
      pathParams: ["tenantId", "campaignId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns/{campaignId}/attestations",
      methodName: "AdminGovernanceSubmitAttestation",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminSubmitAttestationReq",
      responseSchema: "AdminAttestationResp",
      pathParams: ["tenantId", "campaignId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns/{campaignId}/close",
      methodName: "AdminGovernanceCloseCampaign",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCloseCampaignReq",
      responseSchema: "AdminCampaignResp",
      pathParams: ["tenantId", "campaignId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/campaigns/{campaignId}/launch",
      methodName: "AdminGovernanceLaunchCampaign",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminLaunchCampaignReq",
      responseSchema: "AdminCampaignResp",
      pathParams: ["tenantId", "campaignId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/discovery",
      methodName: "AdminGovernanceListDiscovery",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListDiscoveryReq",
      responseSchema: "AdminListDiscoveryResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/discovery/run",
      methodName: "AdminGovernanceRunDiscovery",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceRunDiscoveryReq",
      responseSchema: "AdminGovernanceRunDiscoveryResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/drift",
      methodName: "AdminGovernanceDriftReport",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminDriftReportReq",
      responseSchema: "AdminDriftReportResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/dual-auth",
      methodName: "AdminGovernanceListActions",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceListActionsReq",
      responseSchema: "AdminGovernanceListActionsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/dual-auth/propose",
      methodName: "AdminGovernancePropose",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceProposeReq",
      responseSchema: "AdminGovernanceActionResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/dual-auth/{actionId}/approve",
      methodName: "AdminGovernanceApprove",
      description: "Records the second approval of a pending dual-auth governance action and executes it. Send an empty JSON object as the body. The caller needs the dual-auth approval permission and must be a human user distinct from the proposer. A machine client_credentials caller is refused with 403 Forbidden for every action kind, and the proposer's own approval is refused with 409 Conflict.",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceApproveReq",
      responseSchema: "AdminGovernanceActionResp",
      pathParams: ["tenantId", "actionId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/dual-auth/{actionId}/reject",
      methodName: "AdminGovernanceReject",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceRejectReq",
      responseSchema: "AdminGovernanceActionResp",
      pathParams: ["tenantId", "actionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/role-defs",
      methodName: "AdminListRoleDefs",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListRoleDefsReq",
      responseSchema: "AdminListRoleDefsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/governance/role-defs",
      methodName: "AdminCreateRoleDef",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateRoleDefReq",
      responseSchema: "AdminRoleDefResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/governance/role-defs/{name}",
      methodName: "AdminDeleteRoleDef",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetRoleDefReq",
      responseSchema: "AdminRoleDefResp",
      pathParams: ["tenantId", "name"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/role-defs/{name}",
      methodName: "AdminGetRoleDef",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetRoleDefReq",
      responseSchema: "AdminRoleDefResp",
      pathParams: ["tenantId", "name"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/governance/role-defs/{name}",
      methodName: "AdminUpdateRoleDef",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateRoleDefReq",
      responseSchema: "AdminRoleDefResp",
      pathParams: ["tenantId", "name"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/governance/roles",
      methodName: "AdminGovernanceListRoles",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceListRolesReq",
      responseSchema: "AdminGovernanceListRolesResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/governance/roles/{subjectId}",
      methodName: "AdminGovernanceAssignRole",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGovernanceAssignRoleReq",
      responseSchema: "AdminGovernanceActionResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/mail-provider",
      methodName: "AdminDeleteMailProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetMailProviderReq",
      responseSchema: "AdminMailProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/mail-provider",
      methodName: "AdminGetMailProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetMailProviderReq",
      responseSchema: "AdminMailProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/mail-provider",
      methodName: "AdminPutMailProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPutMailProviderReq",
      responseSchema: "AdminMailProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/mfa-policy",
      methodName: "AdminGetMFAPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetMFAPolicyReq",
      responseSchema: "AdminMFAPolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/mfa-policy",
      methodName: "AdminSetMFAPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminSetMFAPolicyReq",
      responseSchema: "AdminMFAPolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/mtls/cas",
      methodName: "AdminListTenantClientCAs",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListTenantClientCAsReq",
      responseSchema: "AdminClientCAListResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/pam/resilience/health",
      methodName: "AdminPAMResilienceHealth",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPAMResilienceHealthReq",
      responseSchema: "AdminPAMResilienceHealthResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/pam/resilience/maintenance",
      methodName: "AdminPAMMaintenanceToggle",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPAMMaintenanceToggleReq",
      responseSchema: "AdminPAMMaintenanceToggleResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/pam/resilience/slo",
      methodName: "AdminPAMSLODashboard",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPAMSLODashboardReq",
      responseSchema: "AdminPAMSLODashboardResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/pam/resilience/status",
      methodName: "AdminPAMResilienceStatus",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPAMResilienceStatusReq",
      responseSchema: "AdminPAMResilienceStatusResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/policies",
      methodName: "AdminListPolicies",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListPoliciesReq",
      responseSchema: "AdminListPoliciesResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/policies",
      methodName: "AdminCreatePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreatePolicyReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/policies/simulate",
      methodName: "AdminSimulatePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminSimulatePolicyReq",
      responseSchema: "AdminSimulatePolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}",
      methodName: "AdminDeletePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetPolicyReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId", "policyId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}",
      methodName: "AdminGetPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetPolicyReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId", "policyId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}",
      methodName: "AdminUpdatePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreatePolicyReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId", "policyId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}/rollback",
      methodName: "AdminRollbackPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRollbackPolicyReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId", "policyId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}/versions",
      methodName: "AdminListPolicyVersions",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPolicyVersionsReq",
      responseSchema: "AdminPolicyVersionsResp",
      pathParams: ["tenantId", "policyId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/policies/{policyId}/versions/{version}",
      methodName: "AdminGetPolicyVersion",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPolicyVersionReq",
      responseSchema: "AdminPolicyResp",
      pathParams: ["tenantId", "policyId", "version"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/profile-policy",
      methodName: "AdminGetProfilePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetProfilePolicyReq",
      responseSchema: "AdminProfilePolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/profile-policy",
      methodName: "AdminPutProfilePolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPutProfilePolicyReq",
      responseSchema: "AdminProfilePolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/resources",
      methodName: "AdminListResources",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListResourcesReq",
      responseSchema: "AdminListResourcesResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/resources",
      methodName: "AdminCreateResource",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateResourceReq",
      responseSchema: "AdminResourceResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/resources/{resourceId}",
      methodName: "AdminDeleteResource",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetResourceReq",
      responseSchema: "AdminResourceResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/resources/{resourceId}",
      methodName: "AdminGetResource",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetResourceReq",
      responseSchema: "AdminResourceResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/resources/{resourceId}",
      methodName: "AdminUpdateResource",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateResourceReq",
      responseSchema: "AdminResourceResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/secrets-provider",
      methodName: "AdminDeleteSecretsProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSecretsProviderReq",
      responseSchema: "AdminSecretsProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/secrets-provider",
      methodName: "AdminGetSecretsProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSecretsProviderReq",
      responseSchema: "AdminSecretsProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/secrets-provider",
      methodName: "AdminPutSecretsProvider",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminPutSecretsProviderReq",
      responseSchema: "AdminSecretsProviderResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/session-control-policies/{resourceId}",
      methodName: "AdminDeleteSessionControlPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSessionControlPolicyReq",
      responseSchema: "AdminSessionControlPolicyResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/session-control-policies/{resourceId}",
      methodName: "AdminGetSessionControlPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSessionControlPolicyReq",
      responseSchema: "AdminSessionControlPolicyResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/session-control-policies/{resourceId}",
      methodName: "AdminSetSessionControlPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminSetSessionControlPolicyReq",
      responseSchema: "AdminSessionControlPolicyResp",
      pathParams: ["tenantId", "resourceId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/stepup/policy",
      methodName: "AdminGetStepUpPolicy",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetStepUpPolicyReq",
      responseSchema: "AdminGetStepUpPolicyResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/subjects",
      methodName: "AdminListSubjects",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListSubjectsReq",
      responseSchema: "AdminListSubjectsResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/subjects",
      methodName: "AdminCreateSubject",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateSubjectReq",
      responseSchema: "AdminSubjectResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/subjects/{subjectId}",
      methodName: "AdminDeleteSubject",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSubjectReq",
      responseSchema: "AdminSubjectResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/subjects/{subjectId}",
      methodName: "AdminGetSubject",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSubjectReq",
      responseSchema: "AdminSubjectResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/subjects/{subjectId}",
      methodName: "AdminUpdateSubject",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateSubjectReq",
      responseSchema: "AdminSubjectResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/subjects/{subjectId}/security-history",
      methodName: "AdminGetSubjectSecurityHistory",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetSubjectSecurityHistoryReq",
      responseSchema: "AdminGetUserSecurityHistoryResp",
      pathParams: ["tenantId", "subjectId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users",
      methodName: "AdminListUsers",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListUsersReq",
      responseSchema: "AdminListUsersResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/users",
      methodName: "AdminCreateUser",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminCreateUserReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}",
      methodName: "AdminDeleteUser",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetUserReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}",
      methodName: "AdminGetUser",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetUserReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}",
      methodName: "AdminUpdateUser",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUpdateUserReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/app-passwords",
      methodName: "AdminListUserAppPasswords",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListUserAppPasswordsReq",
      responseSchema: "AdminAppPasswordsResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/app-passwords/{appPasswordId}",
      methodName: "AdminRevokeUserAppPassword",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRevokeUserAppPasswordReq",
      responseSchema: "AdminRevokeUserAppPasswordResp",
      pathParams: ["tenantId", "userId", "appPasswordId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/factors",
      methodName: "AdminListUserFactors",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminListUserFactorsReq",
      responseSchema: "AdminListUserFactorsResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/factors/{factorKind}/{factorId}",
      methodName: "AdminRevokeUserFactor",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminRevokeUserFactorReq",
      responseSchema: "AdminRevokeUserFactorResp",
      pathParams: ["tenantId", "userId", "factorKind", "factorId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/password",
      methodName: "AdminUserPasswordReset",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUserPasswordResetReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/profile",
      methodName: "AdminGetUserProfile",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetUserProfileReq",
      responseSchema: "AdminUserProfileResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "PUT",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/profile",
      methodName: "AdminSetUserProfile",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminSetUserProfileReq",
      responseSchema: "AdminUserProfileResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/revoke-sessions",
      methodName: "AdminUserRevokeSessions",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminUserRevokeSessionsReq",
      responseSchema: "AdminUserResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/tenants/{tenantId}/users/{userId}/security-history",
      methodName: "AdminGetUserSecurityHistory",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminGetUserSecurityHistoryReq",
      responseSchema: "AdminGetUserSecurityHistoryResp",
      pathParams: ["tenantId", "userId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/admin/whoami",
      methodName: "AdminWhoAmI",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 100,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "AdminMTLSEmptyReq",
      responseSchema: "AdminWhoAmIResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/init/admin",
      methodName: "InitCreateAdmin",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "sensitive",
      surface: "admin",
    },
      requestSchema: "InitCreateAdminReq",
      responseSchema: "InitCreateAdminResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/init/begin",
      methodName: "InitBegin",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "InitBeginReq",
      responseSchema: "InitBeginResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/init/complete",
      methodName: "InitComplete",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "InitCompleteReq",
      responseSchema: "InitCompleteResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/init/status",
      methodName: "InitStatus",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "InitStatusReq",
      responseSchema: "InitStatusResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/discover",
      methodName: "Discover",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "DiscoverReq",
      responseSchema: "DiscoverResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/email/verify-secondary/confirm",
      methodName: "SecondaryEmailVerifyConfirm",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "SecondaryEmailVerifyConfirmReq",
      responseSchema: "SecondaryEmailVerifyConfirmResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/email/verify/confirm",
      methodName: "PostEmailVerifyConfirm",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "EmailVerifyConfirmReq",
      responseSchema: "EmailVerifyConfirmResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/email/verify/request",
      methodName: "PostEmailVerifyRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "EmailVerifyRequestReq",
      responseSchema: "EmailVerifyRequestResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/health",
      methodName: "Health",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 1000,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "HealthReq",
      responseSchema: "HealthResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/jwks",
      methodName: "Jwks",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 500,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "JWKSReq",
      responseSchema: "JWKSResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/magic-link/request",
      methodName: "PostMagicLinkRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 5,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MagicLinkRequestReq",
      responseSchema: "MagicLinkRequestResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/magic-link/verify",
      methodName: "PostMagicLinkVerify",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MagicLinkVerifyReq",
      responseSchema: "MagicLinkVerifyResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/me/app-passwords",
      methodName: "MeListAppPasswords",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListAppPasswordsReq",
      responseSchema: "MeAppPasswordsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/me/app-passwords",
      methodName: "MeCreateAppPassword",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeCreateAppPasswordReq",
      responseSchema: "MeCreateAppPasswordResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/oidc/me/app-passwords/{appPasswordId}",
      methodName: "MeRevokeAppPassword",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeRevokeAppPasswordReq",
      responseSchema: "MeRevokeAppPasswordResp",
      pathParams: ["appPasswordId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/me/emails",
      methodName: "MeListEmails",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListEmailsReq",
      responseSchema: "MeEmailsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/me/emails",
      methodName: "MeAddEmail",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 5,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeAddEmailReq",
      responseSchema: "MeAddEmailResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/oidc/me/emails/{emailId}",
      methodName: "MeDeleteEmail",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeDeleteEmailReq",
      responseSchema: "MeDeleteEmailResp",
      pathParams: ["emailId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/me/emails/{emailId}/primary",
      methodName: "MeSetPrimaryEmail",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 5,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeSetPrimaryEmailReq",
      responseSchema: "MeEmailsResp",
      pathParams: ["emailId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/me/profile",
      methodName: "MeGetProfile",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetProfileReq",
      responseSchema: "MeProfileResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/oidc/me/profile",
      methodName: "MeUpdateProfile",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeUpdateProfileReq",
      responseSchema: "MeProfileResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/mfa/totp/disable",
      methodName: "TOTPDisable",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "TOTPDisableReq",
      responseSchema: "TOTPDisableResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/mfa/totp/enroll/begin",
      methodName: "TOTPEnrollBegin",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "TOTPEnrollBeginReq",
      responseSchema: "TOTPEnrollBeginResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/mfa/totp/enroll/verify",
      methodName: "TOTPEnrollVerify",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "TOTPEnrollVerifyReq",
      responseSchema: "TOTPEnrollVerifyResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/password/forgot",
      methodName: "PostPasswordForgot",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "PasswordForgotReq",
      responseSchema: "PasswordForgotResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/password/reset",
      methodName: "PostPasswordReset",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "PasswordResetReq",
      responseSchema: "PasswordResetResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/recovery-key/generate",
      methodName: "RecoveryKeyGenerate",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "RecoveryKeyGenerateReq",
      responseSchema: "RecoveryKeyGenerateResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/recovery-key/redeem",
      methodName: "RecoveryKeyRedeem",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "RecoveryKeyRedeemReq",
      responseSchema: "RecoveryKeyRedeemResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/register",
      methodName: "PostOIDCRegister",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "RegisterReq",
      responseSchema: "RegisterResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/security-questions/set",
      methodName: "PostSecurityQuestionsSet",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 10,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "SecurityQuestionsSetReq",
      responseSchema: "SecurityQuestionsSetResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/security-questions/verify",
      methodName: "PostSecurityQuestionsVerify",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 2,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "SecurityQuestionsVerifyReq",
      responseSchema: "SecurityQuestionsVerifyResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/webauthn/authenticate/begin",
      methodName: "PostAuthenticateBegin",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "authenticate begin",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnAuthenticateBeginReq",
      responseSchema: "WebAuthnAuthenticateBeginResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/webauthn/authenticate/complete",
      methodName: "PostAuthenticateComplete",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "authenticate complete",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnAuthenticateCompleteReq",
      responseSchema: "WebAuthnAuthenticateCompleteResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/webauthn/credentials",
      methodName: "WebAuthnListCredentials",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnListCredentialsReq",
      responseSchema: "WebAuthnListCredentialsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "DELETE",
      path: "/v1/oidc/webauthn/credentials/{credentialId}",
      methodName: "WebAuthnDeleteCredential",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnDeleteCredentialReq",
      responseSchema: "WebAuthnDeleteCredentialResp",
      pathParams: ["credentialId"],
      responseKind: "json",
    },
    {
      method: "PATCH",
      path: "/v1/oidc/webauthn/credentials/{credentialId}",
      methodName: "WebAuthnSetCredentialAlias",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnSetCredentialAliasReq",
      responseSchema: "WebAuthnSetCredentialAliasResp",
      pathParams: ["credentialId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/oidc/webauthn/enrollment-status",
      methodName: "WebAuthnEnrollmentStatus",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnEnrollmentStatusReq",
      responseSchema: "WebAuthnEnrollmentStatusResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/webauthn/register/begin",
      methodName: "PostRegisterBegin",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "register begin",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnRegisterBeginReq",
      responseSchema: "WebAuthnRegisterBeginResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/oidc/webauthn/register/complete",
      methodName: "PostRegisterComplete",
      description: "",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "register complete",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "sensitive",
      surface: "public",
    },
      requestSchema: "WebAuthnRegisterCompleteReq",
      responseSchema: "WebAuthnRegisterCompleteResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/access-requests",
      methodName: "MeListAccessRequests",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListAccessRequestsReq",
      responseSchema: "MeListAccessRequestsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/access-requests",
      methodName: "MeCreateAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeCreateAccessRequestReq",
      responseSchema: "MeAccessRequestResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/access-requests/{requestId}",
      methodName: "MeGetAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetAccessRequestReq",
      responseSchema: "MeAccessRequestResp",
      pathParams: ["requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/access-requests/{requestId}/activate",
      methodName: "MeActivateAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 20,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeActivateAccessRequestReq",
      responseSchema: "PamAccessRequestActivationResp",
      pathParams: ["requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/access-requests/{requestId}/cancel",
      methodName: "MeCancelAccessRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetAccessRequestReq",
      responseSchema: "MeAccessRequestResp",
      pathParams: ["requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/approvals",
      methodName: "MeListApprovals",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListApprovalsReq",
      responseSchema: "MeListApprovalsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/approvals/{requestId}/approve",
      methodName: "MeApproveRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 30,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeApproveRequestReq",
      responseSchema: "MeAccessRequestResp",
      pathParams: ["requestId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/approvals/{requestId}/deny",
      methodName: "MeDenyRequest",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 30,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeDenyRequestReq",
      responseSchema: "MeAccessRequestResp",
      pathParams: ["requestId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/credentials",
      methodName: "MeListCredentials",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListCredentialsReq",
      responseSchema: "MeListCredentialsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/credentials/issue",
      methodName: "MeIssueCredential",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeIssueCredentialReq",
      responseSchema: "MeEphemeralCredResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/credentials/{leaseId}",
      methodName: "MeGetCredential",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetCredentialReq",
      responseSchema: "MeCredentialLeaseResp",
      pathParams: ["leaseId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/credentials/{leaseId}/revoke",
      methodName: "MeRevokeCredential",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeRevokeCredentialReq",
      responseSchema: "MeRevokeCredentialResp",
      pathParams: ["leaseId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/entitlements",
      methodName: "MeListEntitlements",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 60,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListEntitlementsReq",
      responseSchema: "MeListEntitlementsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/grants",
      methodName: "MeListGrants",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListGrantsReq",
      responseSchema: "MeListGrantsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/grants/{grantId}",
      methodName: "MeGetGrant",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetGrantReq",
      responseSchema: "MeGetGrantResp",
      pathParams: ["grantId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/sessions",
      methodName: "MeListSessions",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeListSessionsReq",
      responseSchema: "MeListSessionsResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/sessions",
      methodName: "MeInitiateSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeInitiateSessionReq",
      responseSchema: "MeBrokeredSessionResp",
      pathParams: [],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/pam/me/sessions/{sessionId}",
      methodName: "MeGetSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 200,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeGetSessionReq",
      responseSchema: "MeBrokeredSessionResp",
      pathParams: ["sessionId"],
      responseKind: "json",
    },
    {
      method: "POST",
      path: "/v1/pam/me/sessions/{sessionId}/end",
      methodName: "MeEndSession",
      description: "",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 50,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "MeEndSessionReq",
      responseSchema: "MeBrokeredSessionResp",
      pathParams: ["sessionId"],
      responseKind: "json",
    },
    {
      method: "GET",
      path: "/v1/tenants/{tenantId}/apikeys/revoked",
      methodName: "ListRevokedAPIKeys",
      description: "Genuinely PUBLIC (unauthenticated) revoked-jti list: returns the tenant's currently-revoked-and-not-yet-expired API-key key_ids (jtis) so relying parties can poll and cache a denylist. No auth, no PermTenantAPIKeysManage gate -- the list carries only opaque jtis, never a secret or any other key metadata (ThreadID API keys core, Task 8).",
      auth: {
      mode: "",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "n/a",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 500,
      sensitivity: "normal",
      surface: "public",
    },
      requestSchema: "ListRevokedAPIKeysReq",
      responseSchema: "ListRevokedAPIKeysResp",
      pathParams: ["tenantId"],
      responseKind: "json",
    },
  ],
  websockets: [
    {
      path: "/ws/oidc/events",
      proto: "json",
      methodName: "Events",
      auth: {
      mode: "jwt",
      composite: null,
      dnf: [],
      roles: [],
      scopes: [],
      attributes: {  },
      csrf: "",
      mtlsRequired: false,
      mtlsEku: false,
      mtlsIssuers: [],
      webauthn: "",
      webhook: false,
      webhookSignatureHeader: "",
      webhookSecretEnv: "",
      rateLimit: 0,
      sensitivity: "sensitive",
      surface: "websocket",
    },
      messageSchema: "OIDCEventMsg",
    },
  ],
  graphql: null,
  mcp: [
    {
      name: "get_jwks",
      title: "",
      description: "",
      paramsSchema: "JWKSReq",
      resultSchema: "JWKSResp",
    },
    {
      name: "get_openid_configuration",
      title: "",
      description: "",
      paramsSchema: "DiscoverReq",
      resultSchema: "DiscoverResp",
    },
  ],
  schemas: {
    "APIKeyRoleCatalogEntry": {
      name: "APIKeyRoleCatalogEntry",
      fields: [
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "label",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "role",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AccessRequestItem": {
      name: "AccessRequestItem",
      fields: [
        {
          name: "actions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "activatedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approverIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "denialReason",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "idempotencyKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "linkedUserId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "purpose",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedById",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedDurationSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "startTime",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectLifecycle",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "ticketRef",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAPIKeyResp": {
      name: "AdminAPIKeyResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdBy",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "keyId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "revokedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "rotatedFrom",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subject",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAPIKeySecretResp": {
      name: "AdminAPIKeySecretResp",
      fields: [
        {
          name: "apiKey",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "keyId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAccessRequestResp": {
      name: "AdminAccessRequestResp",
      fields: [
        {
          name: "actions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "activatedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approverIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "denialReason",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "idempotencyKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "purpose",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedById",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedDurationSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "startTime",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "ticketRef",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminActivateBreakGlassReq": {
      name: "AdminActivateBreakGlassReq",
      fields: [
        {
          name: "emergencyRoleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppClaimsSurfacePreviewResp": {
      name: "AdminAppClaimsSurfacePreviewResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "clientsBound",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "exampleFailures",
          tsType: "Array<AdminClaimsSurfacePreviewFailure>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "failCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "passCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "previewToken",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "previewTokenExpiresAt",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sampleLimit",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sampleTruncated",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectsExamined",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "view",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "warnings",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppClaimsSurfaceResp": {
      name: "AdminAppClaimsSurfaceResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "rules",
          tsType: "Array<AdminClaimRuleItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "view",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppItem": {
      name: "AdminAppItem",
      fields: [
        {
          name: "attributes",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "parentId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "path",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppPasswordsResp": {
      name: "AdminAppPasswordsResp",
      fields: [
        {
          name: "appPasswords",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppResp": {
      name: "AdminAppResp",
      fields: [
        {
          name: "apiKeyRoleCatalog",
          tsType: "Array<APIKeyRoleCatalogEntry>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "attributes",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "parentId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "path",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppRoleAssignmentItem": {
      name: "AdminAppRoleAssignmentItem",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppRoleAssignmentResp": {
      name: "AdminAppRoleAssignmentResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppRoleItem": {
      name: "AdminAppRoleItem",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAppRoleResp": {
      name: "AdminAppRoleResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminApproveAccessRequestReq": {
      name: "AdminApproveAccessRequestReq",
      fields: [
        {
          name: "rationale",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminAttestationResp": {
      name: "AdminAttestationResp",
      fields: [
      ],
    },
    "AdminBreakGlassEventResp": {
      name: "AdminBreakGlassEventResp",
      fields: [
      ],
    },
    "AdminBrokeredSessionResp": {
      name: "AdminBrokeredSessionResp",
      fields: [
      ],
    },
    "AdminCAEConfigResp": {
      name: "AdminCAEConfigResp",
      fields: [
        {
          name: "thresholds",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCAEEventResp": {
      name: "AdminCAEEventResp",
      fields: [
        {
          name: "eventType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "occurredAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "payload",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "recordedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "severity",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectRef",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCAERiskStateResp": {
      name: "AdminCAERiskStateResp",
      fields: [
        {
          name: "computedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "contributingIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "currentLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectRef",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCampaignResp": {
      name: "AdminCampaignResp",
      fields: [
      ],
    },
    "AdminClaimRuleItem": {
      name: "AdminClaimRuleItem",
      fields: [
        {
          name: "key",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "required",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "suppress",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokens",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "value",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminClaimsSurfacePreviewFailure": {
      name: "AdminClaimsSurfacePreviewFailure",
      fields: [
        {
          name: "missingRequired",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminClientCAListResp": {
      name: "AdminClientCAListResp",
      fields: [
      ],
    },
    "AdminClientCAResp": {
      name: "AdminClientCAResp",
      fields: [
        {
          name: "createdAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "fingerprint",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "label",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "notAfter",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pem",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminClientItem": {
      name: "AdminClientItem",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantTypes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "postLogoutRedirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "public",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUris",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpointAuthMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenExchangeEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminClientResp": {
      name: "AdminClientResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantTypes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "postLogoutRedirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "public",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUris",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "serviceAccountRoles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpointAuthMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenExchangeEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCloseCampaignReq": {
      name: "AdminCloseCampaignReq",
      fields: [
        {
          name: "campaignId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCompleteBreakGlassReviewReq": {
      name: "AdminCompleteBreakGlassReviewReq",
      fields: [
        {
          name: "eventId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "notes",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminConnectorItem": {
      name: "AdminConnectorItem",
      fields: [
        {
          name: "config",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminConnectorResp": {
      name: "AdminConnectorResp",
      fields: [
        {
          name: "config",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateAccessRequestReq": {
      name: "AdminCreateAccessRequestReq",
      fields: [
        {
          name: "actions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "approverIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "idempotencyKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "purpose",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestedDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "startTime",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ticketRef",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateAppReq": {
      name: "AdminCreateAppReq",
      fields: [
        {
          name: "apiKeyRoleCatalog",
          tsType: "Array<APIKeyRoleCatalogEntry>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "attributes",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "parentId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateAppRoleAssignmentReq": {
      name: "AdminCreateAppRoleAssignmentReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateAppRoleReq": {
      name: "AdminCreateAppRoleReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateCampaignReq": {
      name: "AdminCreateCampaignReq",
      fields: [
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "dueAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "reviewers",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateClientCAReq": {
      name: "AdminCreateClientCAReq",
      fields: [
        {
          name: "label",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "pem",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateClientReq": {
      name: "AdminCreateClientReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "grantTypes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "postLogoutRedirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "public",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUris",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "serviceAccountRoles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpointAuthMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenExchangeEnabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateClientResp": {
      name: "AdminCreateClientResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientSecret",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantTypes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "postLogoutRedirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "public",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUris",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "serviceAccountRoles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpointAuthMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenExchangeEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateConnectorReq": {
      name: "AdminCreateConnectorReq",
      fields: [
        {
          name: "clientSecret",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "config",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateEmergencyRoleReq": {
      name: "AdminCreateEmergencyRoleReq",
      fields: [
        {
          name: "maxTtlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateEntitlementReq": {
      name: "AdminCreateEntitlementReq",
      fields: [
        {
          name: "candidateSubjects",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "conflictingGroups",
          tsType: "Array<Array<string>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "maxDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requiredApprovals",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "selfApprovalAllowed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreatePolicyReq": {
      name: "AdminCreatePolicyReq",
      fields: [
        {
          name: "conditions",
          tsType: "Array<Record<string, unknown>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "effect",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "policyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "priority",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "target",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateResourceReq": {
      name: "AdminCreateResourceReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approvalPolicyRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "environment",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "metadata",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nativeType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "owner",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateRoleDefReq": {
      name: "AdminCreateRoleDefReq",
      fields: [
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateSubjectReq": {
      name: "AdminCreateSubjectReq",
      fields: [
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "assuranceLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "displayName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "externalIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "lifecycle",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "linkedUserId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskContext",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateTenantReq": {
      name: "AdminCreateTenantReq",
      fields: [
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireMtls",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCreateUserReq": {
      name: "AdminCreateUserReq",
      fields: [
        {
          name: "accountLocked",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "initialPasswordResetRequired",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "password",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCredentialLeaseResp": {
      name: "AdminCredentialLeaseResp",
      fields: [
        {
          name: "expiresAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "revokedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminCredentialProviderResp": {
      name: "AdminCredentialProviderResp",
      fields: [
        {
          name: "configured",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminDeleteAppRoleAssignmentReq": {
      name: "AdminDeleteAppRoleAssignmentReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "assignmentId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminDenyAccessRequestReq": {
      name: "AdminDenyAccessRequestReq",
      fields: [
        {
          name: "rationale",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminDevicePostureResp": {
      name: "AdminDevicePostureResp",
      fields: [
        {
          name: "compliant",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "deviceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "impossibleTravel",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "managed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskScore",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "verified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminDriftReportReq": {
      name: "AdminDriftReportReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminDriftReportResp": {
      name: "AdminDriftReportResp",
      fields: [
        {
          name: "drift",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "driftCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "orphaned",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "orphanedCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "overPrivileged",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "overPrivilegedCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "stale",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "staleCount",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "totalFlagged",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminEmergencyRoleResp": {
      name: "AdminEmergencyRoleResp",
      fields: [
      ],
    },
    "AdminEntitlementItem": {
      name: "AdminEntitlementItem",
      fields: [
        {
          name: "candidateSubjects",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "conflictingGroups",
          tsType: "Array<Array<string>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requiredApprovals",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "selfApprovalAllowed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminEntitlementResp": {
      name: "AdminEntitlementResp",
      fields: [
        {
          name: "candidateSubjects",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "conflictingGroups",
          tsType: "Array<Array<string>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requiredApprovals",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "selfApprovalAllowed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminEphemeralCredResp": {
      name: "AdminEphemeralCredResp",
      fields: [
        {
          name: "caPubKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "credentialMaterial",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "leaseId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "validUntil",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminExtendAccessRequestReq": {
      name: "AdminExtendAccessRequestReq",
      fields: [
        {
          name: "newDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAPIKeyReq": {
      name: "AdminGetAPIKeyReq",
      fields: [
        {
          name: "keyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAccessRequestReq": {
      name: "AdminGetAccessRequestReq",
      fields: [
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAppClaimsSurfaceReq": {
      name: "AdminGetAppClaimsSurfaceReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resolved",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAppReq": {
      name: "AdminGetAppReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAppRoleReq": {
      name: "AdminGetAppRoleReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAuditCaseFileReq": {
      name: "AdminGetAuditCaseFileReq",
      fields: [
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAuditChainIntegrityReq": {
      name: "AdminGetAuditChainIntegrityReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetAuditChainIntegrityResp": {
      name: "AdminGetAuditChainIntegrityResp",
      fields: [
        {
          name: "anomalies",
          tsType: "Array<ChainAnomaly>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tamperSuspected",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "total",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "truncated",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetBreakGlassEventReq": {
      name: "AdminGetBreakGlassEventReq",
      fields: [
        {
          name: "eventId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetBrokeredSessionRecordingsReq": {
      name: "AdminGetBrokeredSessionRecordingsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetBrokeredSessionRecordingsResp": {
      name: "AdminGetBrokeredSessionRecordingsResp",
      fields: [
        {
          name: "entries",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetBrokeredSessionReq": {
      name: "AdminGetBrokeredSessionReq",
      fields: [
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetCAEConfigReq": {
      name: "AdminGetCAEConfigReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetCAEEventReq": {
      name: "AdminGetCAEEventReq",
      fields: [
        {
          name: "eventId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetCAERiskStateReq": {
      name: "AdminGetCAERiskStateReq",
      fields: [
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetCampaignReq": {
      name: "AdminGetCampaignReq",
      fields: [
        {
          name: "campaignId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetClientCAReq": {
      name: "AdminGetClientCAReq",
      fields: [
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetClientReq": {
      name: "AdminGetClientReq",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetConnectorReq": {
      name: "AdminGetConnectorReq",
      fields: [
        {
          name: "connectorId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetCredentialLeaseReq": {
      name: "AdminGetCredentialLeaseReq",
      fields: [
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetDevicePostureReq": {
      name: "AdminGetDevicePostureReq",
      fields: [
        {
          name: "deviceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetEmergencyRoleReq": {
      name: "AdminGetEmergencyRoleReq",
      fields: [
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetEntitlementReq": {
      name: "AdminGetEntitlementReq",
      fields: [
        {
          name: "entitlementId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetMFAPolicyReq": {
      name: "AdminGetMFAPolicyReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetMailProviderReq": {
      name: "AdminGetMailProviderReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetPolicyReq": {
      name: "AdminGetPolicyReq",
      fields: [
        {
          name: "policyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetProfilePolicyReq": {
      name: "AdminGetProfilePolicyReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetResourceReq": {
      name: "AdminGetResourceReq",
      fields: [
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetRoleDefReq": {
      name: "AdminGetRoleDefReq",
      fields: [
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetSecretsProviderReq": {
      name: "AdminGetSecretsProviderReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetSessionControlPolicyReq": {
      name: "AdminGetSessionControlPolicyReq",
      fields: [
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetStepUpPolicyReq": {
      name: "AdminGetStepUpPolicyReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetStepUpPolicyResp": {
      name: "AdminGetStepUpPolicyResp",
      fields: [
        {
          name: "maxAgeSecs",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requirePhishingResistant",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requiredLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetSubjectReq": {
      name: "AdminGetSubjectReq",
      fields: [
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetSubjectSecurityHistoryReq": {
      name: "AdminGetSubjectSecurityHistoryReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "from",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "to",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetTenantReq": {
      name: "AdminGetTenantReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetUserProfileReq": {
      name: "AdminGetUserProfileReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetUserReq": {
      name: "AdminGetUserReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetUserSecurityHistoryReq": {
      name: "AdminGetUserSecurityHistoryReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "from",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "to",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGetUserSecurityHistoryResp": {
      name: "AdminGetUserSecurityHistoryResp",
      fields: [
        {
          name: "activeThreatPoints",
          tsType: "Array<AdminUserActiveThreatHistoryPoint>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskPoints",
          tsType: "Array<AdminUserRiskHistoryPoint>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceActionResp": {
      name: "AdminGovernanceActionResp",
      fields: [
      ],
    },
    "AdminGovernanceApproveReq": {
      name: "AdminGovernanceApproveReq",
      fields: [
        {
          name: "actionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceAssignRoleReq": {
      name: "AdminGovernanceAssignRoleReq",
      fields: [
        {
          name: "kind",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceListActionsReq": {
      name: "AdminGovernanceListActionsReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceListActionsResp": {
      name: "AdminGovernanceListActionsResp",
      fields: [
        {
          name: "actions",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceListRolesReq": {
      name: "AdminGovernanceListRolesReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceListRolesResp": {
      name: "AdminGovernanceListRolesResp",
      fields: [
        {
          name: "assignments",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "note",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceProposeReq": {
      name: "AdminGovernanceProposeReq",
      fields: [
        {
          name: "kind",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "payloadRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceRejectReq": {
      name: "AdminGovernanceRejectReq",
      fields: [
        {
          name: "actionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceRunDiscoveryReq": {
      name: "AdminGovernanceRunDiscoveryReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminGovernanceRunDiscoveryResp": {
      name: "AdminGovernanceRunDiscoveryResp",
      fields: [
        {
          name: "count",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "persisted",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminInitiateBrokeredSessionReq": {
      name: "AdminInitiateBrokeredSessionReq",
      fields: [
        {
          name: "driverType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sshPublicKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminIssueEphemeralCredReq": {
      name: "AdminIssueEphemeralCredReq",
      fields: [
        {
          name: "grantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerParams",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ttlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminKillBrokeredSessionReq": {
      name: "AdminKillBrokeredSessionReq",
      fields: [
        {
          name: "reason",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminLaunchCampaignReq": {
      name: "AdminLaunchCampaignReq",
      fields: [
        {
          name: "campaignId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAPIKeysReq": {
      name: "AdminListAPIKeysReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAPIKeysResp": {
      name: "AdminListAPIKeysResp",
      fields: [
        {
          name: "apiKeys",
          tsType: "Array<AdminAPIKeyResp>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAccessRequestsReq": {
      name: "AdminListAccessRequestsReq",
      fields: [
        {
          name: "approver",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resource",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subject",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "unexpired",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAccessRequestsResp": {
      name: "AdminListAccessRequestsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<AccessRequestItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppChildrenReq": {
      name: "AdminListAppChildrenReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppRoleAssignmentsReq": {
      name: "AdminListAppRoleAssignmentsReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppRoleAssignmentsResp": {
      name: "AdminListAppRoleAssignmentsResp",
      fields: [
        {
          name: "assignments",
          tsType: "Array<AdminAppRoleAssignmentItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppRolesReq": {
      name: "AdminListAppRolesReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppRolesResp": {
      name: "AdminListAppRolesResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<AdminAppRoleItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppsReq": {
      name: "AdminListAppsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAppsResp": {
      name: "AdminListAppsResp",
      fields: [
        {
          name: "apps",
          tsType: "Array<AdminAppItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAttestationsReq": {
      name: "AdminListAttestationsReq",
      fields: [
        {
          name: "campaignId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListAttestationsResp": {
      name: "AdminListAttestationsResp",
      fields: [
        {
          name: "attestations",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListBreakGlassEventsReq": {
      name: "AdminListBreakGlassEventsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListBreakGlassEventsResp": {
      name: "AdminListBreakGlassEventsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListBrokeredSessionsReq": {
      name: "AdminListBrokeredSessionsReq",
      fields: [
        {
          name: "resource",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subject",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListBrokeredSessionsResp": {
      name: "AdminListBrokeredSessionsResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessions",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCAEEventsReq": {
      name: "AdminListCAEEventsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCAEEventsResp": {
      name: "AdminListCAEEventsResp",
      fields: [
        {
          name: "events",
          tsType: "Array<AdminCAEEventResp>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCampaignsResp": {
      name: "AdminListCampaignsResp",
      fields: [
        {
          name: "campaigns",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListClientsReq": {
      name: "AdminListClientsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListClientsResp": {
      name: "AdminListClientsResp",
      fields: [
        {
          name: "clients",
          tsType: "Array<AdminClientItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListConnectorsReq": {
      name: "AdminListConnectorsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListConnectorsResp": {
      name: "AdminListConnectorsResp",
      fields: [
        {
          name: "connectors",
          tsType: "Array<AdminConnectorItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCredentialLeasesReq": {
      name: "AdminListCredentialLeasesReq",
      fields: [
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCredentialLeasesResp": {
      name: "AdminListCredentialLeasesResp",
      fields: [
        {
          name: "leases",
          tsType: "Array<AdminCredentialLeaseResp>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCredentialProvidersReq": {
      name: "AdminListCredentialProvidersReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListCredentialProvidersResp": {
      name: "AdminListCredentialProvidersResp",
      fields: [
        {
          name: "providers",
          tsType: "Array<AdminCredentialProviderResp>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListDiscoveryReq": {
      name: "AdminListDiscoveryReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListDiscoveryResp": {
      name: "AdminListDiscoveryResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListEmergencyRolesReq": {
      name: "AdminListEmergencyRolesReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListEmergencyRolesResp": {
      name: "AdminListEmergencyRolesResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListEntitlementsReq": {
      name: "AdminListEntitlementsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListEntitlementsResp": {
      name: "AdminListEntitlementsResp",
      fields: [
        {
          name: "entitlements",
          tsType: "Array<AdminEntitlementItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListHighRiskSubjectsReq": {
      name: "AdminListHighRiskSubjectsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "minLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListHighRiskSubjectsResp": {
      name: "AdminListHighRiskSubjectsResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjects",
          tsType: "Array<AdminCAERiskStateResp>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListPoliciesReq": {
      name: "AdminListPoliciesReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListPoliciesResp": {
      name: "AdminListPoliciesResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListResourcesReq": {
      name: "AdminListResourcesReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListResourcesResp": {
      name: "AdminListResourcesResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resources",
          tsType: "Array<AdminResourceItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListRoleDefsReq": {
      name: "AdminListRoleDefsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListRoleDefsResp": {
      name: "AdminListRoleDefsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListSubjectsReq": {
      name: "AdminListSubjectsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListSubjectsResp": {
      name: "AdminListSubjectsResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjects",
          tsType: "Array<AdminSubjectItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListTenantClientCAsReq": {
      name: "AdminListTenantClientCAsReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListTenantsReq": {
      name: "AdminListTenantsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListTenantsResp": {
      name: "AdminListTenantsResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenants",
          tsType: "Array<AdminTenantResp>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListUserAppPasswordsReq": {
      name: "AdminListUserAppPasswordsReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListUserFactorsReq": {
      name: "AdminListUserFactorsReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListUserFactorsResp": {
      name: "AdminListUserFactorsResp",
      fields: [
        {
          name: "factors",
          tsType: "Array<AdminUserFactorItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListUsersReq": {
      name: "AdminListUsersReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminListUsersResp": {
      name: "AdminListUsersResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "users",
          tsType: "Array<AdminUserItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminMFAPolicyResp": {
      name: "AdminMFAPolicyResp",
      fields: [
        {
          name: "nonDangerousLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nonDangerousRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireForAdminLogin",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireSecondFactorForPasskeyPrimary",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminMTLSEmptyReq": {
      name: "AdminMTLSEmptyReq",
      fields: [
      ],
    },
    "AdminMTLSStatusResp": {
      name: "AdminMTLSStatusResp",
      fields: [
        {
          name: "count",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminMailProviderResp": {
      name: "AdminMailProviderResp",
      fields: [
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "credentialSet",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "envLocked",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "fromAddr",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "host",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "port",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tlsMode",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "username",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminMintAPIKeyReq": {
      name: "AdminMintAPIKeyReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "audience",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ttlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminOverrideCAERiskReq": {
      name: "AdminOverrideCAERiskReq",
      fields: [
        {
          name: "level",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "reason",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminOverrideCAERiskResp": {
      name: "AdminOverrideCAERiskResp",
      fields: [
        {
          name: "level",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMMaintenanceToggleReq": {
      name: "AdminPAMMaintenanceToggleReq",
      fields: [
        {
          name: "enabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMMaintenanceToggleResp": {
      name: "AdminPAMMaintenanceToggleResp",
      fields: [
        {
          name: "maintenanceMode",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMResilienceHealthReq": {
      name: "AdminPAMResilienceHealthReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMResilienceHealthResp": {
      name: "AdminPAMResilienceHealthResp",
      fields: [
      ],
    },
    "AdminPAMResilienceStatusReq": {
      name: "AdminPAMResilienceStatusReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMResilienceStatusResp": {
      name: "AdminPAMResilienceStatusResp",
      fields: [
      ],
    },
    "AdminPAMSLODashboardReq": {
      name: "AdminPAMSLODashboardReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPAMSLODashboardResp": {
      name: "AdminPAMSLODashboardResp",
      fields: [
      ],
    },
    "AdminPolicyResp": {
      name: "AdminPolicyResp",
      fields: [
        {
          name: "conditions",
          tsType: "Array<Record<string, unknown>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "effect",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "priority",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "target",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "version",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPolicyVersionReq": {
      name: "AdminPolicyVersionReq",
      fields: [
        {
          name: "policyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "version",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPolicyVersionsReq": {
      name: "AdminPolicyVersionsReq",
      fields: [
        {
          name: "policyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPolicyVersionsResp": {
      name: "AdminPolicyVersionsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPreviewAppClaimsSurfaceReq": {
      name: "AdminPreviewAppClaimsSurfaceReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "rules",
          tsType: "Array<AdminClaimRuleItem>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminProfilePolicyResp": {
      name: "AdminProfilePolicyResp",
      fields: [
        {
          name: "allowUserAttributes",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "appPasswordScopes",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "appPasswordsEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "hrEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxAppPasswords",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantManagedFields",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPutAppClaimsSurfaceReq": {
      name: "AdminPutAppClaimsSurfaceReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "previewToken",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "rules",
          tsType: "Array<AdminClaimRuleItem>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPutMailProviderReq": {
      name: "AdminPutMailProviderReq",
      fields: [
        {
          name: "credential",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "fromAddr",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "host",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "port",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tlsMode",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "username",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPutProfilePolicyReq": {
      name: "AdminPutProfilePolicyReq",
      fields: [
        {
          name: "allowUserAttributes",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "appPasswordScopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "appPasswordsEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "hrEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxAppPasswords",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantManagedFields",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminPutSecretsProviderReq": {
      name: "AdminPutSecretsProviderReq",
      fields: [
        {
          name: "address",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "backend",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "credential",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "endpoint",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "kvMount",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "namespace",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "project",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "region",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "vaultUrl",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminQueryAuditReq": {
      name: "AdminQueryAuditReq",
      fields: [
        {
          name: "actor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "event",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "jti",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "outcome",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamRequestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "since",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "until",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminQueryAuditResp": {
      name: "AdminQueryAuditResp",
      fields: [
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "records",
          tsType: "Array<AuditRecord>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRebaselineAuditChainReq": {
      name: "AdminRebaselineAuditChainReq",
      fields: [
        {
          name: "override",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "overrideReason",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRebaselineAuditChainResp": {
      name: "AdminRebaselineAuditChainResp",
      fields: [
        {
          name: "overrideUsed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sealedAnomalies",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sealedCount",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sealedThrough",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tamperSuspected",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminResourceItem": {
      name: "AdminResourceItem",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approvalPolicyRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "environment",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nativeType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "owner",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminResourceResp": {
      name: "AdminResourceResp",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approvalPolicyRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "environment",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nativeType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "owner",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminResumeBrokeredSessionReq": {
      name: "AdminResumeBrokeredSessionReq",
      fields: [
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "stepUpSatisfied",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRevokeCredentialLeaseResp": {
      name: "AdminRevokeCredentialLeaseResp",
      fields: [
        {
          name: "leaseId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRevokeUserAppPasswordReq": {
      name: "AdminRevokeUserAppPasswordReq",
      fields: [
        {
          name: "appPasswordId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRevokeUserAppPasswordResp": {
      name: "AdminRevokeUserAppPasswordResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRevokeUserFactorReq": {
      name: "AdminRevokeUserFactorReq",
      fields: [
        {
          name: "factorId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "factorKind",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRevokeUserFactorResp": {
      name: "AdminRevokeUserFactorResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRoleDefResp": {
      name: "AdminRoleDefResp",
      fields: [
      ],
    },
    "AdminRollbackPolicyReq": {
      name: "AdminRollbackPolicyReq",
      fields: [
        {
          name: "policyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "toVersion",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateAPIKeyReq": {
      name: "AdminRotateAPIKeyReq",
      fields: [
        {
          name: "audience",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "keyId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ttlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateClientSecretReq": {
      name: "AdminRotateClientSecretReq",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateClientSecretResp": {
      name: "AdminRotateClientSecretResp",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "clientSecret",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateCredentialKeyReq": {
      name: "AdminRotateCredentialKeyReq",
      fields: [
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateCredentialKeyResp": {
      name: "AdminRotateCredentialKeyResp",
      fields: [
        {
          name: "newKeyId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "oldKeyId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "rotatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminRotateSigningKeysReq": {
      name: "AdminRotateSigningKeysReq",
      fields: [
      ],
    },
    "AdminRotateSigningKeysResp": {
      name: "AdminRotateSigningKeysResp",
      fields: [
      ],
    },
    "AdminSecretsProviderResp": {
      name: "AdminSecretsProviderResp",
      fields: [
        {
          name: "address",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "backend",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "credentialSet",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "endpoint",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "envLocked",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "kvMount",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "namespace",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "project",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "region",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "vaultUrl",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSessionControlPolicyResp": {
      name: "AdminSessionControlPolicyResp",
      fields: [
        {
          name: "absTtlSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "allowPause",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "idleTtlSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxConcurrentPerSubject",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSetMFAPolicyReq": {
      name: "AdminSetMFAPolicyReq",
      fields: [
        {
          name: "nonDangerousLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nonDangerousRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireForAdminLogin",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireSecondFactorForPasskeyPrimary",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSetSessionControlPolicyReq": {
      name: "AdminSetSessionControlPolicyReq",
      fields: [
        {
          name: "absTtlSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "allowPause",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "idleTtlSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "maxConcurrentPerSubject",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSetUserProfileReq": {
      name: "AdminSetUserProfileReq",
      fields: [
        {
          name: "hr",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "removeAttributes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "setAttributes",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSimulatePolicyReq": {
      name: "AdminSimulatePolicyReq",
      fields: [
        {
          name: "policies",
          tsType: "Array<Record<string, unknown>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "query",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSimulatePolicyResp": {
      name: "AdminSimulatePolicyResp",
      fields: [
        {
          name: "decision",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "denyOverride",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "matchedPolicies",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSubjectItem": {
      name: "AdminSubjectItem",
      fields: [
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "assuranceLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "displayName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "externalIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "lifecycle",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "linkedUserId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSubjectResp": {
      name: "AdminSubjectResp",
      fields: [
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "assuranceLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "displayName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "externalIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "lifecycle",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "linkedUserId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminSubmitAttestationReq": {
      name: "AdminSubmitAttestationReq",
      fields: [
        {
          name: "campaignId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "decision",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "discoveryId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminTenantResp": {
      name: "AdminTenantResp",
      fields: [
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuer",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "protected",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requireMtls",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminTriggerCAEEvaluateReq": {
      name: "AdminTriggerCAEEvaluateReq",
      fields: [
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminTriggerCAEEvaluateResp": {
      name: "AdminTriggerCAEEvaluateResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateAppReq": {
      name: "AdminUpdateAppReq",
      fields: [
        {
          name: "apiKeyRoleCatalog",
          tsType: "Array<APIKeyRoleCatalogEntry>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "attributes",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "parentId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateAppRoleReq": {
      name: "AdminUpdateAppRoleReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateCAEConfigReq": {
      name: "AdminUpdateCAEConfigReq",
      fields: [
        {
          name: "failedAuthBurstCritical",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "failedAuthBurstHigh",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "impossibleTravelKmCritical",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitiveActionRateHigh",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "velocityAnomalyCritical",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "velocityAnomalyHigh",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateCAEConfigResp": {
      name: "AdminUpdateCAEConfigResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateClientCAReq": {
      name: "AdminUpdateClientCAReq",
      fields: [
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateClientReq": {
      name: "AdminUpdateClientReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "grantTypes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "postLogoutRedirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUris",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "serviceAccountRoles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpointAuthMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenExchangeEnabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateConnectorReq": {
      name: "AdminUpdateConnectorReq",
      fields: [
        {
          name: "clientSecret",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "config",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "connectorId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "enabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateEmergencyRoleReq": {
      name: "AdminUpdateEmergencyRoleReq",
      fields: [
        {
          name: "maxTtlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roleId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateEntitlementReq": {
      name: "AdminUpdateEntitlementReq",
      fields: [
        {
          name: "candidateSubjects",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "conflictingGroups",
          tsType: "Array<Array<string>>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "entitlementId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "maxDurationSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requiredApprovals",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "selfApprovalAllowed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateResourceReq": {
      name: "AdminUpdateResourceReq",
      fields: [
        {
          name: "appId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approvalPolicyRef",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "environment",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "metadata",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "nativeType",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "owner",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sensitivity",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateRoleDefReq": {
      name: "AdminUpdateRoleDefReq",
      fields: [
        {
          name: "description",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateSubjectReq": {
      name: "AdminUpdateSubjectReq",
      fields: [
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "assuranceLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "displayName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "externalIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "lifecycle",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "linkedUserId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskContext",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "type",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateTenantReq": {
      name: "AdminUpdateTenantReq",
      fields: [
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requireMtls",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpdateUserReq": {
      name: "AdminUpdateUserReq",
      fields: [
        {
          name: "accountLocked",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "passwordResetRequired",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUpsertDevicePostureReq": {
      name: "AdminUpsertDevicePostureReq",
      fields: [
        {
          name: "compliant",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "deviceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "impossibleTravel",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "managed",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "riskScore",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "verified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserActiveThreatHistoryPoint": {
      name: "AdminUserActiveThreatHistoryPoint",
      fields: [
        {
          name: "actorSub",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "level",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "recordedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "score",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserFactorItem": {
      name: "AdminUserFactorItem",
      fields: [
        {
          name: "createdAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "kind",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserItem": {
      name: "AdminUserItem",
      fields: [
        {
          name: "accountLocked",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "passwordResetRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "securityOnboardingRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserPasswordResetReq": {
      name: "AdminUserPasswordResetReq",
      fields: [
        {
          name: "password",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserProfileResp": {
      name: "AdminUserProfileResp",
      fields: [
        {
          name: "attributes",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "familyName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "givenName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "hr",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "picture",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sub",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantManagedFields",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserResp": {
      name: "AdminUserResp",
      fields: [
        {
          name: "accountLocked",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "activeThreatLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "pamAccessDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "passwordResetRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "privilegeEscalationDisabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "riskLevel",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "securityOnboardingRequired",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserRevokeSessionsReq": {
      name: "AdminUserRevokeSessionsReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminUserRiskHistoryPoint": {
      name: "AdminUserRiskHistoryPoint",
      fields: [
        {
          name: "actorSub",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "level",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "recordedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "score",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "source",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AdminWhoAmIResp": {
      name: "AdminWhoAmIResp",
      fields: [
        {
          name: "adminRole",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "roles",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sub",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenant",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "AuditRecord": {
      name: "AuditRecord",
      fields: [
        {
          name: "actorSub",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "catalogCode",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "event",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "jti",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "outcome",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "pamRequestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resource",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "timestamp",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "ChainAnomaly": {
      name: "ChainAnomaly",
      fields: [
        {
          name: "atUnixNano",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "computedRecordHash",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "eventCode",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "expectedPrevHash",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "explanation",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "index",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "kind",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "matchesIndex",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "recordId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "storedPrevHash",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "storedRecordHash",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "DiscoverReq": {
      name: "DiscoverReq",
      fields: [
      ],
    },
    "DiscoverResp": {
      name: "DiscoverResp",
      fields: [
        {
          name: "authorizationEndpoint",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantType",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "issuer",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "jwksUri",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "responseType",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "subjectType",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tokenEndpoint",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tokenSigningAlg",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userinfoEndpoint",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "EmailVerifyConfirmReq": {
      name: "EmailVerifyConfirmReq",
      fields: [
        {
          name: "token",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
      ],
    },
    "EmailVerifyConfirmResp": {
      name: "EmailVerifyConfirmResp",
      fields: [
        {
          name: "verified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "EmailVerifyRequestReq": {
      name: "EmailVerifyRequestReq",
      fields: [
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "EmailVerifyRequestResp": {
      name: "EmailVerifyRequestResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "HealthReq": {
      name: "HealthReq",
      fields: [
      ],
    },
    "HealthResp": {
      name: "HealthResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "uptimeSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "version",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "InitBeginReq": {
      name: "InitBeginReq",
      fields: [
      ],
    },
    "InitBeginResp": {
      name: "InitBeginResp",
      fields: [
        {
          name: "initialized",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "steps",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "InitCompleteReq": {
      name: "InitCompleteReq",
      fields: [
      ],
    },
    "InitCompleteResp": {
      name: "InitCompleteResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "InitCreateAdminReq": {
      name: "InitCreateAdminReq",
      fields: [
        {
          name: "email",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "password",
          tsType: "string",
          required: false,
          secret: true,
          hash: "",
        },
      ],
    },
    "InitCreateAdminResp": {
      name: "InitCreateAdminResp",
      fields: [
        {
          name: "adminId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "InitStatusReq": {
      name: "InitStatusReq",
      fields: [
      ],
    },
    "InitStatusResp": {
      name: "InitStatusResp",
      fields: [
        {
          name: "initialized",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "setupTokenEnabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "steps",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "JWK": {
      name: "JWK",
      fields: [
        {
          name: "alg",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "e",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "kid",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "kty",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "n",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "use",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "JWKSReq": {
      name: "JWKSReq",
      fields: [
      ],
    },
    "JWKSResp": {
      name: "JWKSResp",
      fields: [
        {
          name: "keys",
          tsType: "Array<JWK>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "ListRevokedAPIKeysReq": {
      name: "ListRevokedAPIKeysReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "ListRevokedAPIKeysResp": {
      name: "ListRevokedAPIKeysResp",
      fields: [
        {
          name: "refreshSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "revoked",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MagicLinkRequestReq": {
      name: "MagicLinkRequestReq",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallenge",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallengeMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nonce",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUri",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MagicLinkRequestResp": {
      name: "MagicLinkRequestResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MagicLinkVerifyReq": {
      name: "MagicLinkVerifyReq",
      fields: [
        {
          name: "securityAnswers",
          tsType: "Array<SecurityQuestionItem>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "token",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
      ],
    },
    "MagicLinkVerifyResp": {
      name: "MagicLinkVerifyResp",
      fields: [
        {
          name: "code",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "mfaRequired",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectTo",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "responseKind",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeAccessRequestResp": {
      name: "MeAccessRequestResp",
      fields: [
        {
          name: "actions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "activatedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "approverIds",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "denialReason",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "idempotencyKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "purpose",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedById",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "requestedDurationSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "startTime",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "ticketRef",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "updatedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeActivateAccessRequestReq": {
      name: "MeActivateAccessRequestReq",
      fields: [
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeAddEmailReq": {
      name: "MeAddEmailReq",
      fields: [
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeAddEmailResp": {
      name: "MeAddEmailResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeAppPasswordsResp": {
      name: "MeAppPasswordsResp",
      fields: [
        {
          name: "appPasswords",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeApproveRequestReq": {
      name: "MeApproveRequestReq",
      fields: [
        {
          name: "rationale",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeBrokeredSessionResp": {
      name: "MeBrokeredSessionResp",
      fields: [
      ],
    },
    "MeCreateAccessRequestReq": {
      name: "MeCreateAccessRequestReq",
      fields: [
        {
          name: "actions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "idempotencyKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "justification",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "permissions",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "purpose",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestedDurationSeconds",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "startTime",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ticketRef",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeCreateAppPasswordReq": {
      name: "MeCreateAppPasswordReq",
      fields: [
        {
          name: "expiresInDays",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "label",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeCreateAppPasswordResp": {
      name: "MeCreateAppPasswordResp",
      fields: [
        {
          name: "createdAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "expiresAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "label",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scopes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "secret",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeCredentialLeaseResp": {
      name: "MeCredentialLeaseResp",
      fields: [
        {
          name: "expiresAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "id",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuedAt",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "revokedAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "subjectId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeDeleteEmailReq": {
      name: "MeDeleteEmailReq",
      fields: [
        {
          name: "emailId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeDeleteEmailResp": {
      name: "MeDeleteEmailResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeDenyRequestReq": {
      name: "MeDenyRequestReq",
      fields: [
        {
          name: "reason",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "requestId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeEmailsResp": {
      name: "MeEmailsResp",
      fields: [
        {
          name: "emails",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeEndSessionReq": {
      name: "MeEndSessionReq",
      fields: [
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeEphemeralCredResp": {
      name: "MeEphemeralCredResp",
      fields: [
        {
          name: "caPubKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "credentialMaterial",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "leaseId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "validUntil",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeGetAccessRequestReq": {
      name: "MeGetAccessRequestReq",
      fields: [
        {
          name: "requestId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeGetCredentialReq": {
      name: "MeGetCredentialReq",
      fields: [
        {
          name: "leaseId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeGetGrantReq": {
      name: "MeGetGrantReq",
      fields: [
        {
          name: "grantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeGetGrantResp": {
      name: "MeGetGrantResp",
      fields: [
      ],
    },
    "MeGetProfileReq": {
      name: "MeGetProfileReq",
      fields: [
      ],
    },
    "MeGetSessionReq": {
      name: "MeGetSessionReq",
      fields: [
        {
          name: "sessionId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeInitiateSessionReq": {
      name: "MeInitiateSessionReq",
      fields: [
        {
          name: "driverType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sshPublicKey",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeIssueCredentialReq": {
      name: "MeIssueCredentialReq",
      fields: [
        {
          name: "grantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "issuerParams",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "issuerType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "resourceId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "ttlSeconds",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListAccessRequestsReq": {
      name: "MeListAccessRequestsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListAccessRequestsResp": {
      name: "MeListAccessRequestsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<AccessRequestItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListAppPasswordsReq": {
      name: "MeListAppPasswordsReq",
      fields: [
      ],
    },
    "MeListApprovalsReq": {
      name: "MeListApprovalsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListApprovalsResp": {
      name: "MeListApprovalsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListCredentialsReq": {
      name: "MeListCredentialsReq",
      fields: [
      ],
    },
    "MeListCredentialsResp": {
      name: "MeListCredentialsResp",
      fields: [
        {
          name: "leases",
          tsType: "Array<MeCredentialLeaseResp>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListEmailsReq": {
      name: "MeListEmailsReq",
      fields: [
      ],
    },
    "MeListEntitlementsReq": {
      name: "MeListEntitlementsReq",
      fields: [
      ],
    },
    "MeListEntitlementsResp": {
      name: "MeListEntitlementsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<AdminEntitlementItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListGrantsReq": {
      name: "MeListGrantsReq",
      fields: [
        {
          name: "cursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "limit",
          tsType: "number",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListGrantsResp": {
      name: "MeListGrantsResp",
      fields: [
        {
          name: "items",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nextCursor",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeListSessionsReq": {
      name: "MeListSessionsReq",
      fields: [
      ],
    },
    "MeListSessionsResp": {
      name: "MeListSessionsResp",
      fields: [
        {
          name: "sessions",
          tsType: "Array<Record<string, unknown>>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeProfileResp": {
      name: "MeProfileResp",
      fields: [
        {
          name: "attributes",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "emailVerified",
          tsType: "boolean",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "familyName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "givenName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "hr",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "picture",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sub",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantManagedFields",
          tsType: "Array<string>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeRevokeAppPasswordReq": {
      name: "MeRevokeAppPasswordReq",
      fields: [
        {
          name: "appPasswordId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeRevokeAppPasswordResp": {
      name: "MeRevokeAppPasswordResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeRevokeCredentialReq": {
      name: "MeRevokeCredentialReq",
      fields: [
        {
          name: "leaseId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeRevokeCredentialResp": {
      name: "MeRevokeCredentialResp",
      fields: [
        {
          name: "leaseId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeSetPrimaryEmailReq": {
      name: "MeSetPrimaryEmailReq",
      fields: [
        {
          name: "emailId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "MeUpdateProfileReq": {
      name: "MeUpdateProfileReq",
      fields: [
        {
          name: "familyName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "givenName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "picture",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "removeAttributes",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "setAttributes",
          tsType: "Record<string, unknown>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "OIDCEventMsg": {
      name: "OIDCEventMsg",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "eventType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "timestamp",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "PamAccessRequestActivationResp": {
      name: "PamAccessRequestActivationResp",
      fields: [
        {
          name: "accessToken",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "expiresIn",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "grantId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "privileged",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tokenType",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "PasswordForgotReq": {
      name: "PasswordForgotReq",
      fields: [
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "PasswordForgotResp": {
      name: "PasswordForgotResp",
      fields: [
        {
          name: "status",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "PasswordResetReq": {
      name: "PasswordResetReq",
      fields: [
        {
          name: "newPassword",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
        {
          name: "securityAnswers",
          tsType: "Array<SecurityQuestionItem>",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "token",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
      ],
    },
    "PasswordResetResp": {
      name: "PasswordResetResp",
      fields: [
        {
          name: "reset",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "RecoveryKeyGenerateReq": {
      name: "RecoveryKeyGenerateReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "RecoveryKeyGenerateResp": {
      name: "RecoveryKeyGenerateResp",
      fields: [
        {
          name: "recoveryKey",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "RecoveryKeyRedeemReq": {
      name: "RecoveryKeyRedeemReq",
      fields: [
        {
          name: "recoveryKey",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "RecoveryKeyRedeemResp": {
      name: "RecoveryKeyRedeemResp",
      fields: [
        {
          name: "redeemed",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "RegisterReq": {
      name: "RegisterReq",
      fields: [
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "familyName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "givenName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "name",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "password",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
      ],
    },
    "RegisterResp": {
      name: "RegisterResp",
      fields: [
        {
          name: "emailVerified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecondaryEmailVerifyConfirmReq": {
      name: "SecondaryEmailVerifyConfirmReq",
      fields: [
        {
          name: "token",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
      ],
    },
    "SecondaryEmailVerifyConfirmResp": {
      name: "SecondaryEmailVerifyConfirmResp",
      fields: [
        {
          name: "verified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecurityQuestionItem": {
      name: "SecurityQuestionItem",
      fields: [
        {
          name: "answer",
          tsType: "string",
          required: true,
          secret: true,
          hash: "",
        },
        {
          name: "question",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecurityQuestionsSetReq": {
      name: "SecurityQuestionsSetReq",
      fields: [
        {
          name: "questions",
          tsType: "Array<SecurityQuestionItem>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecurityQuestionsSetResp": {
      name: "SecurityQuestionsSetResp",
      fields: [
        {
          name: "count",
          tsType: "number",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecurityQuestionsVerifyReq": {
      name: "SecurityQuestionsVerifyReq",
      fields: [
        {
          name: "answers",
          tsType: "Array<SecurityQuestionItem>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "email",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "SecurityQuestionsVerifyResp": {
      name: "SecurityQuestionsVerifyResp",
      fields: [
        {
          name: "verified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPDisableReq": {
      name: "TOTPDisableReq",
      fields: [
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPDisableResp": {
      name: "TOTPDisableResp",
      fields: [
        {
          name: "disabled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPEnrollBeginReq": {
      name: "TOTPEnrollBeginReq",
      fields: [
        {
          name: "account",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPEnrollBeginResp": {
      name: "TOTPEnrollBeginResp",
      fields: [
        {
          name: "otpauthUri",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "secret",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPEnrollVerifyReq": {
      name: "TOTPEnrollVerifyReq",
      fields: [
        {
          name: "code",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "tenantId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "TOTPEnrollVerifyResp": {
      name: "TOTPEnrollVerifyResp",
      fields: [
        {
          name: "verified",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnAuthenticateBeginReq": {
      name: "WebAuthnAuthenticateBeginReq",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallenge",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallengeMethod",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nonce",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUri",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnAuthenticateBeginResp": {
      name: "WebAuthnAuthenticateBeginResp",
      fields: [
        {
          name: "options",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnAuthenticateCompleteReq": {
      name: "WebAuthnAuthenticateCompleteReq",
      fields: [
        {
          name: "clientId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallenge",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "codeChallengeMethod",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "credential",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "nonce",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "scope",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnAuthenticateCompleteResp": {
      name: "WebAuthnAuthenticateCompleteResp",
      fields: [
        {
          name: "code",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectTo",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "redirectUri",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "responseKind",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "state",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnCredentialSummary": {
      name: "WebAuthnCredentialSummary",
      fields: [
        {
          name: "aaguid",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "alias",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "createdAt",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "credentialId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "transports",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnDeleteCredentialReq": {
      name: "WebAuthnDeleteCredentialReq",
      fields: [
        {
          name: "credentialId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnDeleteCredentialResp": {
      name: "WebAuthnDeleteCredentialResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnEnrollmentStatusReq": {
      name: "WebAuthnEnrollmentStatusReq",
      fields: [
      ],
    },
    "WebAuthnEnrollmentStatusResp": {
      name: "WebAuthnEnrollmentStatusResp",
      fields: [
        {
          name: "enrolled",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnListCredentialsReq": {
      name: "WebAuthnListCredentialsReq",
      fields: [
      ],
    },
    "WebAuthnListCredentialsResp": {
      name: "WebAuthnListCredentialsResp",
      fields: [
        {
          name: "credentials",
          tsType: "Array<WebAuthnCredentialSummary>",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnRegisterBeginReq": {
      name: "WebAuthnRegisterBeginReq",
      fields: [
        {
          name: "attestation",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "authenticatorAttachment",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "displayName",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "userId",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnRegisterBeginResp": {
      name: "WebAuthnRegisterBeginResp",
      fields: [
        {
          name: "options",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnRegisterCompleteReq": {
      name: "WebAuthnRegisterCompleteReq",
      fields: [
        {
          name: "credential",
          tsType: "Record<string, unknown>",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "sessionId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnRegisterCompleteResp": {
      name: "WebAuthnRegisterCompleteResp",
      fields: [
        {
          name: "aaguid",
          tsType: "string",
          required: false,
          secret: false,
          hash: "",
        },
        {
          name: "credentialId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "transports",
          tsType: "Array<string>",
          required: false,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnSetCredentialAliasReq": {
      name: "WebAuthnSetCredentialAliasReq",
      fields: [
        {
          name: "alias",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
        {
          name: "credentialId",
          tsType: "string",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
    "WebAuthnSetCredentialAliasResp": {
      name: "WebAuthnSetCredentialAliasResp",
      fields: [
        {
          name: "ok",
          tsType: "boolean",
          required: true,
          secret: false,
          hash: "",
        },
      ],
    },
  },
  mcpAuthMode: "jwt",
  oidcIssuer: "https://oidc.example.com",
};
